import { useEffect, useReducer } from "react"
import GoBack from "../../cta_utils/GoBack"
import { LoaderComponent } from "../../utils/LoaderComponent"
import reducer, { setState } from "../../utils/CommonReducer"
import { get_all_reports } from "./api"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import ConditionalRender from "../../../ConditionalRender"

const initialPageData = {
    isLoading: {pageDataLoader: false},
    data: [],
}

const AllReports = () => {
    const [pageData, pageDataReducer] = useReducer(reducer, initialPageData)
    const {isLoading, data} = pageData;
    const fetchReports = () => {
        setState(pageDataReducer)({isLoading: {pageDataLoader: true}})
        get_all_reports().then((response) => {
            setState(pageDataReducer)({
                data: response.data.data,
                isLoading: {pageDataLoader: false}
            })
        }).catch((error) => {

        })
    }
    useEffect(() => {
        fetchReports();
    }, [])
    const renderReport = (report) => {
        return (
            <div key={report.id} className="list_item" style={{ position: 'relative', padding: '24px 18px' }}>
                <div className="text_body_big_bold truncate" style={{ lineHeight: '20px' }}>{report.title} </div>
                <div className="text_caption_light" style={{ marginTop: 12 }}>created on {report.created_at}</div>
                <div className="line_seperator_ex_light_grey" style={{ margin: "12px 0px 12px" }}></div>
                <div className="flex_container_space_between">
                    <Link to={`/reports/${report.id}`} className="text_subtitle_light">Go to report</Link>
                </div>
            </div>
        )
    }
    const renderReports = () => {
        return (
            <div>
                <ConditionalRender if={data.length > 0}>
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px'}}>
                    {data && data.map(report => renderReport(report))}
                </div>
                </ConditionalRender>
                <ConditionalRender if={data.length === 0}>
                    <div className="text_body_light" style={{ fontSize: '20px', marginTop: 113, textAlign: 'center' }}>
                        No reports created yet
                    </div>
                </ConditionalRender>
            </div>
        )
    }
    return (
        <div style={{background: "#FAFBFC", padding: '44px 0px', minHeight: '100vh'}}>
        <div className="aggregate_container" style={{maxWidth: "880px"}}>
            <div className="default_flex_container">
            <GoBack className="default_flex_container text_link hover_under_line" style={{marginRight: 8, marginBottom: 10, filter: 'grayscale(100%)'}} text="" arrow_color={"green"}/>
            <div className="text_title_big" style={{marginBottom: "10px"}}>Reports</div>
            </div>
            {
                !isLoading.pageDataLoader ? renderReports():
                (<div style={{height: '100vh'}}>
                    <LoaderComponent isLoading={true}  loaderStyle={{width: 32, margin: '36px auto', display: 'block'}}/>
                </div>)
            }
        </div>
    </div>
    )
}
export default AllReports